<!-- 展会-实勘详情页 -->
<script setup lang="ts">
definePageMeta({
  name: 'inspections-expo-exchange-slug',
  layout: 'default',
  hideDefaultTopNav: true,
})
</script>

<template>
  <HeaderWikiBitPcTopNav :always-expand-search="true" :force-solid-background="true" />
  <SurveyInspectionDetailContent page-variant="expo" />
</template>
